/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {RJSFSchemas} from './RJSFSchemas';
import {RJSFSchemasFromJSON, RJSFSchemasFromJSONTyped, RJSFSchemasToJSON} from './RJSFSchemas';

/**
 *
 * @export
 * @interface BaseUpdateOut
 */
export interface BaseUpdateOut {
  /**
   *
   * @type {boolean}
   * @memberof BaseUpdateOut
   */
  treeChanged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BaseUpdateOut
   */
  dataChanged: boolean;
  /**
   *
   * @type {{ [key: string]: RJSFSchemas; }}
   * @memberof BaseUpdateOut
   */
  schemas: {[key: string]: RJSFSchemas} | null;
}

/**
 * Check if a given object implements the BaseUpdateOut interface.
 */
export function instanceOfBaseUpdateOut(value: object): value is BaseUpdateOut {
  if (!('dataChanged' in value) || value['dataChanged'] === undefined) return false;
  if (!('schemas' in value) || value['schemas'] === undefined) return false;
  return true;
}

export function BaseUpdateOutFromJSON(json: any): BaseUpdateOut {
  return BaseUpdateOutFromJSONTyped(json, false);
}

export function BaseUpdateOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseUpdateOut {
  if (json == null) {
    return json;
  }
  return {
    treeChanged: json['tree_changed'] == null ? undefined : json['tree_changed'],
    dataChanged: json['data_changed'],
    schemas: json['schemas'] == null ? null : mapValues(json['schemas'], RJSFSchemasFromJSON)
  };
}

export function BaseUpdateOutToJSON(value?: BaseUpdateOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    tree_changed: value['treeChanged'],
    data_changed: value['dataChanged'],
    schemas: value['schemas'] == null ? null : mapValues(value['schemas'], RJSFSchemasToJSON)
  };
}
